import React, { Component } from 'react';
import TrainingListItem from './TrainingListItem';
import PropTypes from 'prop-types';

export default class TrainingList extends Component {

  static propTypes = {
    materials: PropTypes.array.isRequired,
    searchQueryData: PropTypes.string.isRequired,
  };


  render() {
    const { materials, searchQueryData } = this.props;

    if (materials && searchQueryData && !materials.length) {
      return (
        <React.Fragment>
          <div className="themes-search__education">
            {`Результат поиска «${searchQueryData}»:`}
          </div>
          <div className="list-entries">
            <div className="list-entries-row">
              <div>По вашему запросу ничего не найдено</div>
              <div>Попробуйте изменить ключевое слово</div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (!materials) {
      return (<div> Обучающих материалов нет :( </div>);
    }

    if (searchQueryData) {
      return (
        <React.Fragment>
          <div className="themes-search__education">
            {`Результат поиска «${searchQueryData}»:`}
          </div>
          <div className="list-entries">
            {materials.map(item => (<TrainingListItem key={item.id} material={item} />))}
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="list-entries">
          {materials.map(item => (<TrainingListItem key={item.id} material={item} />))}
        </div>
      </React.Fragment>
    );
  }
}
